export const assertStatusCode = (code: number) => (code >= 200 && code <= 300) || code === 400;
